import { render, staticRenderFns } from "./VoiceRoom.vue?vue&type=template&id=23f3935b&"
import script from "./VoiceRoom.vue?vue&type=script&lang=js&"
export * from "./VoiceRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports